import request from '@/utils/request'
const apiPath = '/temp/templateMaterialsShareAnalyze'
import { downloadBlob } from '@/utils/download'
const templateMaterialsShareAnalyzeApi = {
  /**
   * 新增【模版分享物料】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【模版分享物料】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【模版分享物料】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【模版分享物料】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【模版分享物料】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【模版分享物料】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  downloadExcelTemplate(query) {
    return request.get(`${apiPath}/downloadExcelTemplate`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '下载模板.xlsx'))
  },
  importExcel(data) {
    return request.post(apiPath + '/importExcel', data)
  },
  /**
   * 获取转发列表
   */
  getForwardList(query) {
    return request.get(`${apiPath}/getForwardList`, { params: query })
  },


 /**
   * 导出【物料分享分析】
   */
 MaterialsShareExport(query) {
  return request.get(`${apiPath}/exportMaterialsShareAnalyze`, { params: query })
}
}
export default templateMaterialsShareAnalyzeApi
